import * as z from 'zod';

import { currencyInput, percentageInput } from '@/_schemas/generic';

export const commissionTiersQuerySchema = z.object({
  id: z.number(),
  commission_plan_id: z.number(),
  min_amount: currencyInput.querySchema(),
  max_amount: currencyInput.querySchema(),
  one_time_perc_bump: percentageInput.querySchema(),
  recurring_perc_bump: percentageInput.querySchema(),
  sort_order: z.number(),
});

export type CommissionTiersQuerySchema = z.infer<typeof commissionTiersQuerySchema>;

const commissionTiersFormSchemaRaw = commissionTiersQuerySchema.extend({
  min_amount: currencyInput.formSchema(),
  max_amount: currencyInput.formSchema(),
  one_time_perc_bump: percentageInput.formSchema(),
  recurring_perc_bump: percentageInput.formSchema(),
});

export const commissionTiersFormSchema = commissionTiersFormSchemaRaw.refine(
  ({ min_amount, max_amount }) => {
    return (
      (currencyInput.formToUpdateConverter(max_amount) ?? 0) >= (currencyInput.formToUpdateConverter(min_amount) ?? 0)
    );
  },
  { error: 'Max Amount must be greater than or equal to Min Amount', path: ['max_amount'] }
);

export type CommissionTiersFormSchema = z.infer<typeof commissionTiersFormSchema>;

export const commissionTiersMutationSchema = commissionTiersFormSchemaRaw.extend({
  one_time_perc_bump: percentageInput.mutationSchema(),
  recurring_perc_bump: percentageInput.mutationSchema(),
  min_amount: percentageInput.mutationSchema(),
  max_amount: percentageInput.mutationSchema(),
});

export type CommissionTiersMutationSchema = z.infer<typeof commissionTiersMutationSchema>;

export const commissionTiersCreateSchema = commissionTiersMutationSchema.omit({
  id: true,
});

export type CommissionTiersCreateSchema = z.infer<typeof commissionTiersCreateSchema>;
